//Importación de librerias
//---------------SICCIJ---------------
//Catalogos
import C001Areas from '../../../src/components/SICCIJ/Comun/Catalogos/001Areas.vue'
import C012TiposEstatusDeCitas from '../../../src/components/SICCIJ/Comun/Catalogos/012TiposEstatusDeCitas.vue'
import C013TiposTramites from '../../../src/components/SICCIJ/Comun/Catalogos/013TiposTramites.vue'
import C014TiposEstatusDeTramitesCitas from '../../../src/components/SICCIJ/Comun/Catalogos/014TiposEstatusDeTramitesCitas.vue'
import C015TiposEstatusDeExpedientes from '../../../src/components/SICCIJ/Comun/Catalogos/015TiposEstatusDeExpedientes.vue'
import C004AgendaBloqueFechas from '../../../src/components/SICCIJ/Comun/Catalogos/C004AgendaBloquesFechas.vue'
import C004AgendaBloqueHoras from '../../../src/components/SICCIJ/Comun/Catalogos/C004AgendaBloquesHoras.vue'


//Creamos y asignamos los datos necesarios de SICCIJ
const siccij = [
  { Proviene: 'SICCIJ', Nombre: 'C001Areas', datos: C001Areas },
  { Proviene: 'SICCIJ', Nombre: 'C012TiposEstatusDeCitas', datos: C012TiposEstatusDeCitas },
  { Proviene: 'SICCIJ', Nombre: 'C013TiposTramites', datos: C013TiposTramites },
  { Proviene: 'SICCIJ', Nombre: 'C014TiposEstatusDeTramitesCitas', datos: C014TiposEstatusDeTramitesCitas },
  { Proviene: 'SICCIJ', Nombre: 'C015TiposEstatusDeExpedientes', datos: C015TiposEstatusDeExpedientes },
  { Proviene: 'SICCIJ', Nombre: 'C004AgendaBloqueFechas', datos: C004AgendaBloqueFechas },
    { Proviene: 'SICCIJ', Nombre: 'C004AgendaBloqueHoras', datos: C004AgendaBloqueHoras }
]


//Exportamos los datos de SICCIJ
export default siccij;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/siccij.js
// module id = null
// module chunks = 